var map = {
	"./action.svg": 21,
	"./address-location.svg": 15,
	"./arrow-to-left.svg": 22,
	"./arrow-to-top.svg": 23,
	"./arrows-back.svg": 16,
	"./back.svg": 24,
	"./checked.svg": 25,
	"./checked2.svg": 26,
	"./circle-cross.svg": 17,
	"./close.svg": 27,
	"./cross.svg": 28,
	"./down.svg": 29,
	"./github.svg": 30,
	"./hook-red.svg": 18,
	"./message.svg": 31,
	"./minus.svg": 11,
	"./more.svg": 32,
	"./more2.svg": 33,
	"./more3.svg": 34,
	"./notice.svg": 35,
	"./plus.svg": 12,
	"./qrcode.svg": 36,
	"./right.svg": 37,
	"./search.svg": 38,
	"./search2.svg": 39,
	"./share.svg": 40,
	"./tick-red.svg": 19,
	"./tick.svg": 41,
	"./top.svg": 42,
	"./trolley.svg": 43,
	"./unchecked.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;